import { MinzeElement } from 'minze'

export interface LvcGreenCheckmarkIcon {}

export class LvcGreenCheckmarkIcon extends MinzeElement {
  html = () => `
  <svg width="10" height="8" viewBox="0 0 10 8" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M9 1C7.23547 2.85595 5.48215 4.92427 3.81971 6.89896C3.71614 7.02199 3.53984 7.03436 3.42224 6.92677C2.48263 6.06715 1.79847 5.41116 1 4.32864" stroke="#34A853" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

  
  `

  css = () => `
    
  `
}
